import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => {
  return {
    cardContent: {
      padding: `0px 0px 0px ${token.marginXXS}px`,
      marginBottom: `${token.marginXXS + token.marginXXS / 2}px`,
      overflow: 'hidden'
    },

    collapse: {
      '.ant-collapse-item .ant-collapse-header': {
        padding: 0
      }
    },

    titleMaxWidth: {
      maxWidth: '120px !important'
    },

    noMarginRight: {
      marginRight: 0
    },

    deadLine: {
      fontWeight: 500
    },

    deadLineExpired: {
      fontWeight: 500,
      color: token.red5
    },

    card: {
      cursor: 'grab',
      '.ant-card-body': {
        padding: `${token.marginXS}px ${token.marginXS}px ${token.marginXS}px ${token.marginXXS}px`
      },

      '&:hover': {
        '& .ant-card-body > div:first-child .ant-row .ant-col:last-child button':
          {
            opacity: 1
          }
      }
    },

    expandButton: {
      opacity: 0,
      transition: `opacity ${token.motionDurationMid}s`
    }
  }
})
